import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskUnmarkedUrgent_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskUnmarkedUrgent_ActivityLogFragment;
}

const ActivityLogTaskUnmarkedUrgent: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.unmarkedUrgent"
    />
  );
};

ActivityLogTaskUnmarkedUrgent.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskUnmarkedUrgent_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskUnmarkedUrgent;
